import { render, staticRenderFns } from "./TankLorry.vue?vue&type=template&id=0df5fdbe"
import script from "./TankLorry.vue?vue&type=script&lang=js"
export * from "./TankLorry.vue?vue&type=script&lang=js"
import style0 from "./TankLorry.vue?vue&type=style&index=0&id=0df5fdbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports